import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { useWorkspace } from './WorkspaceContext';

const AssigneeContext = createContext();

export const useAssignees = () => {
  const context = useContext(AssigneeContext);
  if (!context) {
    throw new Error('useAssignees must be used within AssigneeProvider');
  }
  return context;
};

export const AssigneeProvider = ({ children }) => {
  const [assignees, setAssignees] = useState([]);
  const [loading, setLoading] = useState(false);
  const { currentWorkspace } = useWorkspace();

  useEffect(() => {
    const controller = new AbortController();
    let isStale = false;

    if (!currentWorkspace?.id) {
      setAssignees([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    api
      .get('assignees/', {
        params: { workspace_id: currentWorkspace.id },
        signal: controller.signal,
      })
      .then((response) => {
        if (isStale) return;
        setAssignees(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (isStale) return;
        if (error?.name === 'CanceledError' || error?.name === 'AbortError') {
          return;
        }
        console.error('Error fetching assignees:', error);
        setAssignees([]);
        setLoading(false);
      });

    return () => {
      isStale = true;
      controller.abort();
    };
  }, [currentWorkspace?.id]);

  return (
    <AssigneeContext.Provider value={{ assignees, loading }}>
      {children}
    </AssigneeContext.Provider>
  );
};
